import React from 'react'
import { Card, Spacer, Text } from '@geist-ui/react'

const Layout: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <Card>
      <Text h3>Google Auth example in imToken</Text>
      <Spacer y={2} />
      {children}
    </Card>
  )
}

export default Layout
